import { useProperties } from '@providers';
import { extractFilter } from '@utils';
import { Link } from 'react-router-dom';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type SearchFormProps = {
  area: string;
  setArea: (area: string) => void;
};

export const SearchForm: FC<SearchFormProps> = (props) => {
  const { t } = useTranslation();

  const { allAreasWithProperties, properties } = useProperties();
  const [aim, setAim] = useState<string | undefined>(undefined);
  const [subCategory, setSubCategory] = useState<string | undefined>(undefined);

  const aims = useMemo(() => {
    return extractFilter('aim', properties);
  }, [properties]);

  const subCategories = useMemo(() => {
    return extractFilter('subCategory', properties);
  }, [properties]);

  return (
    <div className='ltn__car-dealer-form-area'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='ltn__car-dealer-form-tab'>
              <div className='tab-content bg-opacity-75 bg-white box-shadow-1 ltn__border position-relative pb-10'>
                <div
                  className='tab-pane fade active show'
                  id='ltn__form_tab_1_1'
                >
                  <div className='car-dealer-form-inner'>
                    <form action='#' className='ltn__car-dealer-form-box row'>
                      <div className='ltn__car-dealer-form-item col-lg-3 col-md-6'>
                        <select
                          className='nice-select'
                          value={props.area}
                          onChange={(e) => props.setArea(e.target.value)}
                        >
                          <option value=''>{t('searchForm.chooseArea')}</option>
                          {allAreasWithProperties.map((area) => (
                            <option key={area} value={area}>
                              {area}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='ltn__car-dealer-form-item col-lg-3 col-md-6'>
                        <select
                          className='nice-select'
                          value={aim}
                          onChange={(e) => setAim(e.target.value)}
                        >
                          <option value=''>
                            {t('searchForm.propertyStatus')}
                          </option>
                          {aims.map((aim) => (
                            <option key={aim.text} value={aim.text}>
                              {aim.text}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='ltn__car-dealer-form-item col-lg-3 col-md-6'>
                        <select
                          className='nice-select'
                          value={subCategory}
                          onChange={(e) => setSubCategory(e.target.value)}
                        >
                          <option value=''>
                            {t('subcategorySelect.label')}
                          </option>
                          {subCategories.map((sc) => (
                            <option key={sc.text} value={sc.text}>
                              {sc.text}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='ltn__car-dealer-form-item ltn__custom-icon ltn__icon-calendar col-lg-3 col-md-6'>
                        <div className='btn-wrapper text-center mt-0'>
                          <Link
                            to={`/properties?subCategory=${subCategory || ''}&aim=${aim || ''}&area=${props.area || ''}`}
                            className={`btn theme-btn-1 btn-effect-1 text-uppercase ${!properties?.length ? 'disabled' : ''}`}
                          >
                            {t('searchForm.findNow')}
                          </Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
